import {
  getApiUrl,
  getToken,
  getApplication,
} from "../constants/settings.constant";

import { downloadFile } from "../utils/file.util";

import http from "./http";

let qs = require("qs");

function getChats(params) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return new Promise((resolve, reject) => {
    http
      .get(`${api}/chats`, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
        params: {
          ...params,
        },
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: "repeat" }),
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function putChat(chatId, chat) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/chats/${chatId}`, chat, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function archiveChat(chatId) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/chats/${chatId}/archive`, null, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function getChatMessages(chatId, params) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return new Promise((resolve, reject) => {
    http
      .get(`${api}/chats/${chatId}/messages`, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
        params: {
          ...params,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function viewMessage(chatId, messageId) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/chats/${chatId}/messages/${messageId}/viewed`, null, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function viewChat(chatId) {
  const api = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().apiURL
    : "http://192.168.3.173/social-service/api";
  const application = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().application
    : "";
  const token = window.hasOwnProperty("Social")
    ? window.Social.getApiConfig().token
    : "";

  return new Promise((resolve, reject) => {
    http
      .put(`${api}/chats/${chatId}/messages/viewed`, null, {
        headers: {
          application: application,
          "ticket-sso": token,
        },
      })
      .then((res) => {
        resolve(res);
      });
  });
}

function getUsers(chatId) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return http.get(`${api}/chats/${chatId}/users`, {
    headers: {
      application: application,
      "ticket-sso": token,
    },
    params: {
      enabled: true,
    },
  });
}

function uploadAttachment(chatId, file) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  const formData = new FormData();
  formData.append("file", file);

  return http.post(`${api}/attachments/${chatId}`, formData, {
    headers: {
      application: application,
      "ticket-sso": token,
      "Content-Type": "multipart/form-data",
    },
  });
}

function fetchAttachmentBlob(messageId) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return http.get(`${api}/attachments/${messageId}/download`, {
    headers: {
      application: application,
      "ticket-sso": token,
    },
    responseType: "blob",
  });
}

function downloadAttachment(messageId, fileName) {
  return new Promise((resolve, reject) => {
    fetchAttachmentBlob(messageId)
      .then((res) => {
        downloadFile(res.data, fileName);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function viewAttachment(messageId) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  const url = `${api}/attachments/${messageId}/view?application=${application}&ticket-sso=${token}`;

  window.open(url, "_blank");
}

function getProcessInstance(chatId) {
  const api = getApiUrl();
  const token = getToken();
  const application = getApplication();

  return http.get(`${api}/chats/${chatId}/process-instance`, {
    headers: {
      application: application,
      "ticket-sso": token,
    },
  });
}

export default {
  getChats,
  putChat,
  archiveChat,
  getChatMessages,
  viewMessage,
  viewChat,
  getUsers,
  uploadAttachment,
  downloadAttachment,
  viewAttachment,
  getProcessInstance,
};
